var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlert(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7489 11.6219L10.5205 1.11236C9.90531 0.0614048 8.44433 -0.313937 7.36781 0.28661C6.98335 0.511815 6.67577 0.812088 6.52198 1.11236L0.29358 11.6219C-0.321571 12.6729 0.0628982 14.0992 1.13941 14.6997C1.52388 14.9249 1.90835 15 2.29282 15H14.6727C15.9799 15 16.9795 13.949 16.9795 12.748C17.0564 12.2975 16.9027 11.9222 16.7489 11.6219ZM8.52122 11.9973C8.05986 11.9973 7.75228 11.697 7.75228 11.2466C7.75228 10.7962 8.05986 10.4959 8.52122 10.4959C8.98259 10.4959 9.29016 10.7962 9.29016 11.2466C9.29016 11.697 8.98259 11.9973 8.52122 11.9973ZM9.29016 8.24385C9.29016 8.69426 8.98259 8.99453 8.52122 8.99453C8.05986 8.99453 7.75228 8.69426 7.75228 8.24385V5.24112C7.75228 4.79071 8.05986 4.49044 8.52122 4.49044C8.98259 4.49044 9.29016 4.79071 9.29016 5.24112V8.24385Z",
    fill: "#D70F57"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.9c529de471ca6a6597534bcaf17ff10b.svg";
export { ForwardRef as ReactComponent };